import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Layout from 'components/Layout'
import RevenueCenters from 'components/RevenueCenters'
import ListFilters from 'components/RevenueCenters/ListFilters'

import {
  clearEditRevenueCenter,
  clearLocationSettings,
  clearMenuSettings,
  loadAvailaibility,
  loadPaginatedAndFilteredRevenueCenters,
} from 'store/RevenueCenters/actions'
import { loadMenus } from 'store/Menus/actions'
import { clearServiceTypes } from 'store/RevenueCenters/actions'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import useEmailAuth from 'hooks/useEmailAuth'
import { getQueryStringParameters } from 'store/AppState/selector'

const RevenueCentersPage = () => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()

  const venueUuid = useSelector((state) => getCurrentVenueUuid(state))
  const isVenueNexter = useEmailAuth()
  const queryStringParameters = useSelector((state) =>
    getQueryStringParameters(state, pathname)
  )

  const params = {
    venueUuid,
    includeSettings: isVenueNexter,
    ...queryStringParameters,
  }

  useEffect(() => {
    dispatch(loadAvailaibility(venueUuid))
    dispatch(loadPaginatedAndFilteredRevenueCenters(params))
    dispatch(loadMenus(venueUuid, isVenueNexter))
    dispatch(clearServiceTypes())
    dispatch(clearLocationSettings())
    dispatch(clearMenuSettings())
    dispatch(clearEditRevenueCenter())
  }, [dispatch, venueUuid])

  return (
    <Layout
      isSidebar
      title="Revenue Centers"
      mainContent={<RevenueCenters queryStringParameters={params} />}
      navbarContent={<ListFilters queryStringParameters={params} />}
    />
  )
}

export default RevenueCentersPage
